// Function loadNewsTemplate loads the NewsTemplate class by dynamically importing the js on demand if needed

export function loadNewsTemplate($parentEl, isList = false) {


	let $wg = $parentEl.querySelector('[data-wg="NewsTemplate"]');

	if(!$wg) {
		// console.info('NewsTemplate: no widget found');
		return Promise.reject('ArticleGallery widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-news-template-chunk" */ '../widgets/newsTemplate').then(wg => {

		const { NewsTemplate } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="NewsTemplate"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new NewsTemplate($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new NewsTemplate($wg);
		}


	}).catch(error => error+'An error occurred while loading the NewsTemplate widget');

}
